import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { SN_BRAND_NAME } from '../../providers/brand-name.provider';

@Component({
  selector: 'sn-brand-name, [snBrandName]',
  template: '{{ name }}',
  styleUrls: ['./brand-name.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-brand-name',
  },
})
export class SnBrandNameComponent {
  constructor(@Inject(SN_BRAND_NAME) public readonly name: string) {}
}
